import React from 'react';
import styled from 'styled-components';
import { EmailDomainState } from 'src/models/Email/EmailDomain';

const preffixDataAid = 'email-domain-state';

const EmailDomainStateComponent = ({ state }: { state: EmailDomainState }): JSX.Element => {
  if (state === EmailDomainState.ACTIVE) {
    return <Status data-aid={`${preffixDataAid}-active`}>Verified</Status>;
  }
  if (state === EmailDomainState.DISABLED) {
    return <DisabledStatus data-aid={`${preffixDataAid}-disabled`}>Disabled</DisabledStatus>;
  }

  return <UnverifiedStatus data-aid={`${preffixDataAid}-unverified`}>Unverified</UnverifiedStatus>;
};

const Status = styled.span`
  background: #d8f4d8;
  border-radius: 8px;
  color: ${p => p.theme.colors.black};
  display: inline-block;
  font-size: 10px;
  line-height: 16px;
  padding: 0 8px;
  &:first-letter {
    text-transform: uppercase;
  }
`;

const DisabledStatus = styled(Status)`
  background: ${p => p.theme.colors.gray500};
`;

const UnverifiedStatus = styled(Status)`
  background: ${p => p.theme.colors.yellow200};
`;

export default EmailDomainStateComponent;
